import { useState, useRef } from 'react';

// Utils
import { getPoint } from '../../../../../../common/maths/geometry/point';
import { getSelectionMarqueeDimensions } from '../../../../../canvas/selection/selectionMarqueeUtils';

const useDrawingEditorSelectionMarqueeState = () => {
    const [isMarqueeSelectMode, setIsMarqueeSelectModeState] = useState(false);
    const [isAppendMode, setIsAppendState] = useState(false);
    const [initialSelectedPathIdsMap, setInitialSelectedPathIdsMap] = useState(false);
    const [drawingMarqueeDimensions, setDrawingMarqueeDimensions] = useState(null);
    const [viewportMarqueeDimensions, setViewportMarqueeDimensions] = useState(null);
    const drawingStartPosition = useRef();
    const viewportStartPosition = useRef();

    const startMarqueeSelectMode = ({ drawingPoint, viewportPoint, appendMode, selectedPathIdsMap }) => {
        drawingStartPosition.current = getPoint(drawingPoint[0], drawingPoint[1]);
        viewportStartPosition.current = getPoint(viewportPoint.x, viewportPoint.y);
        setIsMarqueeSelectModeState(true);
        setIsAppendState(appendMode);
        setInitialSelectedPathIdsMap(selectedPathIdsMap);
    };

    const dragMarqueeSelectionTo = ({ drawingPoint, viewportPoint }) => {
        const newDrawingPoint = getPoint(drawingPoint[0], drawingPoint[1]);
        const newDrawingMarqueeDimensions = getSelectionMarqueeDimensions(drawingStartPosition.current, newDrawingPoint);
        setDrawingMarqueeDimensions(newDrawingMarqueeDimensions);

        const newViewportPoint = getPoint(viewportPoint.x, viewportPoint.y);
        const newViewportMarqueeDimensions = getSelectionMarqueeDimensions(
            viewportStartPosition.current,
            newViewportPoint,
        );
        setViewportMarqueeDimensions(newViewportMarqueeDimensions);
    };

    const endMarqueeSelectMode = () => {
        setIsMarqueeSelectModeState(false);
        setDrawingMarqueeDimensions(null);
        setViewportMarqueeDimensions(null);
    };

    return {
        isMarqueeSelectMode,
        isAppendMode,
        initialSelectedPathIdsMap,
        drawingMarqueeDimensions,
        viewportMarqueeDimensions,
        startMarqueeSelectMode,
        dragMarqueeSelectionTo,
        endMarqueeSelectMode,
    };
};

export default useDrawingEditorSelectionMarqueeState;
